/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ExclusaoBeneficiarioConsultaAliases {
  ACTION_NOVA_EXCLUSAO = 'action-nova-exclusao',
  AUTOCOMPLETE_DOMAIN = 'autocomplete-domain',
  BUTTON_FECGAR = 'button-fecgar',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DATE_FIELD_0 = 'date-field-0',
  DATE_FIELD_1 = 'date-field-1',
  DECK_0 = 'deck-0',
  FETCH_CONSULTA = 'fetch-consulta',
  FETCH_DOMAIN = 'fetch-domain',
  FETCH_MSG_OPERADORA = 'fetch-msg-operadora',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_DATE_1 = 'field-date-1',
  FIELD_DATE_2 = 'field-date-2',
  FIELD_DOMAIN = 'field-domain',
  FILTER_CONSULTA = 'filter-consulta',
  FILTERED_LIST_0 = 'filtered-list-0',
  HPMS_CUSTOM_CARD = 'hpms-custom-card',
  HPMS_CUSTOM_DIALOG = 'hpms-custom-dialog',
  LAYOUT_0 = 'layout-0',
  MAPPER_DOMAIN = 'mapper-domain',
  MAPPER_MSG_OPERADORA = 'mapper-msg-operadora',
  PANEL_0 = 'panel-0',
  PANEL_1 = 'panel-1',
  PANEL_3 = 'panel-3',
  PANEL_EXCLUSAO_BENEFICIARIO = 'panel-exclusao-beneficiario',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_11 = 'text-11',
  TEXT_DOMAIN = 'text-domain',
  TEXT_MSG_OPERADORA = 'text-msg-operadora',
  TEXT_PROTOCOLO = 'text-protocolo',
}
export { ExclusaoBeneficiarioConsultaAliases };
